<template>
  <b-row>
    <b-col lg="6">
      <b-form-group style="width:150px;" class="mb-2">
        <v-select v-model="customerSelect" :reduce="cus => cus.id" :options="customersOptions" placeholder="-- Tất cả --" @input="parseData()"/>
      </b-form-group>
    </b-col>
    <b-col lg="6" class="text-right">
      <b-button v-b-modal.modal-1 size="sm" :variant="'primary'" :disabled="this.$store.getters['Report/pageListReport'].checkboxes.length === 0">
        <i class="las la-exchange-alt las-small"></i>
        Đổi tiền
      </b-button>
    </b-col>
    <b-col lg="12">
      <span class="report-range-title" v-if="detail">
          {{detail.from_date | formatDateVN}} <i class="las la-arrow-right"></i> {{detail.to_date | formatDateVN}}
      </span>
      <b-button-group size="md" class="mb-3" style="float: right">
        <b-button :variant="categorySelect == 'all' ? 'primary' : 'secondary'" @click="categorySelect = 'all'; parseData()">Tất cả</b-button>
        <b-button :variant="categorySelect == 'sportsbook' ? 'primary' : 'secondary'" @click="categorySelect = 'sportsbook'; parseData()">Sportbook</b-button>
        <b-button :variant="categorySelect == 'casino' ? 'primary' : 'secondary'" @click="categorySelect = 'casino'; parseData()">Casino</b-button>
        <b-button :variant="categorySelect == 'loto' ? 'primary' : 'secondary'" @click="categorySelect = 'loto'; parseData()">Lotto</b-button>
        <b-button :variant="categorySelect == 'other' ? 'primary' : 'secondary'" @click="categorySelect = 'other'; parseData()">Other</b-button>
      </b-button-group>
      <b-table
      :id="id"
      ref="reportListTableRef"
      :bordered="true"
      :items="listReport"
      :fields="reportFields"
      class="table-striped mt-1"
      :primary-key="'id'"
      role="grid"
      aria-describedby="user-list-page-info"
    >
      <template v-slot:cell(stt)="data">
        <span>{{data.item.stt}}</span>
      </template>
      <template v-slot:cell(title)="data">
        <div class="flex align-items-center">
          <span v-html="data.item.space"/>
          <span @click="fetchMember(data.index)">
            <i v-show="data.item.children.length > 0 && data.item && !data.item.toggle" class="las la-caret-square-right"/>
          </span>
          <span @click="recursiveCloseSquare(data.item.custom_id, false)">
            <i v-show="data.item.children.length > 0 && data.item && data.item.toggle" class="las la-caret-square-down"/>
          </span>
          <span class="ml-2">{{ data.item.title }}</span>
        </div>
      </template>
      <template v-slot:cell(gcomm)="data">
        <span v-if="data.item.gross_comm !== null">{{data.item.gross_comm}}</span>
      </template>
      <template v-slot:cell(w_l)="data">
        <span v-if="data.item.mem_winloss !== null">{{data.item.mem_winloss}}</span>
      </template>
      <template v-slot:cell(vnd)="data">
        <span :style="applyNumberStyle(data.item.total_vnd)">{{data.item.total_vnd}}</span>
      </template>
      <template v-slot:cell(usd)="data">
        <span :style="applyNumberStyle(data.item.total_usd)">{{data.item.total_usd}}</span>
      </template>
      <template v-slot:cell(action)="data">
        <div v-if="data.item.showCheckbox">
          <b-form-checkbox v-model="checkboxes" :value="data.item.id || null"></b-form-checkbox>
        </div>
        <div v-if="data.item.showRollback">
          <b-button size="sm" variant="danger" :id="`tooltip-target-${data.item.id}`" style="padding: 0px 5px;" @click="rollbackExchange(data.item.id)">
            <i class="fa fa-close mr-0"></i>
          </b-button>
          <b-tooltip :target="`tooltip-target-${data.item.id}`" triggers="hover" placement="right">
              Hủy đổi tiền
          </b-tooltip>
        </div>
      </template>
      <template v-slot:head(action)>
        <b-form-checkbox v-model="isCheckAll"></b-form-checkbox>
      </template>
      <template v-slot:custom-foot>
        <tr>
          <td></td>
          <td align="right">TỔNG</td>
          <td></td>
          <td></td>
          <td v-if="detailReport.summary_report !== null" align="right" :style="applyNumberStyle(detailReport.summary_report[categorySelect].vnd)">{{applyNumberFormat(detailReport.summary_report[categorySelect].vnd, 'th')}}</td>
          <td v-if="detailReport.summary_report !== null" align="right" :style="applyNumberStyle(detailReport.summary_report[categorySelect].usd)">{{applyNumberFormat(detailReport.summary_report[categorySelect].usd, 'en')}}</td>
          <td></td>
        </tr>
      </template>
    </b-table>
    </b-col>
    <b-modal id="modal-1" title="Nạp / rút" ok-title="Xác nhận" cancel-title="Đóng" size="sm">
      <template #modal-header>
        <h4><i class="las la-exchange-alt"/> ĐỔI TIỀN</h4>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <b-form>
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Đổi từ">
                      <v-select :clearable="false" v-model="modal.from_currency" :reduce="opt => opt.serverId" :options="moneyType" placeholder="Từ"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Thành">
                      <b-form-input disabled size="sm" v-if="modal.from_currency == 1" value="USD"/>
                      <b-form-input disabled size="sm" v-if="modal.from_currency == 2" value="VND"/>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group :label="`Tỷ giá`" v-if="modal.from_currency == 1">
                  <vue-numeric separator="," :precision="8" v-model="modal.rate" class="form-control" style="text-align: right;" placeholder="nhập số" currency-symbol-position="suffix" output-type="Number"></vue-numeric>
                </b-form-group>
                <b-form-group :label="`Tỷ giá`" v-if="modal.from_currency == 2">
                  <vue-numeric separator="," :precision="2" v-model="modal.rate" class="form-control" style="text-align: right;" placeholder="nhập số" currency-symbol-position="suffix" output-type="Number"></vue-numeric>
                </b-form-group>
                <b-form-group :label="`Tương đương`" v-if="modal.from_currency == 2">
                  <h4>$1 = {{modal.rate * 1000 | formatMoney('vi-VN','VND')}}</h4>
                </b-form-group>
                <b-form-group :label="`Tương đương`" v-if="modal.from_currency == 1">
                  <h4>$1 = {{1/modal.rate | formatMoney('vi-VN','VND')}} VND</h4>
                </b-form-group>

              </b-form>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="primary" @click="exchange">Xác nhận</b-button>
        <b-button variant="default" @click="$bvModal.hide('modal-1')">Đóng</b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import { findash } from '../../../config/pluginInit'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { applyNumberStyle, formatNumber, formatNumberByLocale } from '@/utils'
import api from '@/store/api'

function isEmptyData (ele) {
  return (ele.total_vnd === '0' && ele.total_usd === '0') || (ele.total_vnd === 0 && ele.total_usd === 0)
}

export default {
  name: 'ReportDetail',
  async mounted () {
    findash.index()
    this.resetAll()
  },
  created () {
  },
  props: [ 'id', 'detail' ],
  watch: {
    detail: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal.details) {
        this.parseDataArr = newVal
        this.parseData()
      }
    },
    'modal.from_currency': function (newVal, oldVal) {
      switch (newVal) {
        case 1:
          this.modal.rate = 0.00004341
          break
        case 2:
          this.modal.rate = 23
          break
      }
    }
  },
  data () {
    return {
      parseDataArr: null,
      categorySelect: 'all',
      customerSelect: null,
      reportFields: [
        {
          key: 'stt',
          label: '#',
          class: 'text-center'
        },
        {
          key: 'title',
          label: 'THÀNH VIÊN',
          class: 'text-left'
        },
        {
          key: 'gcomm',
          label: 'G.COMM',
          class: 'text-right'
        },
        {
          key: 'w_l',
          label: 'W/L',
          class: 'text-right'
        },
        {
          key: 'vnd',
          label: 'VND',
          class: 'text-right'
        },
        {
          key: 'usd',
          label: 'USD',
          class: 'text-right'
        },
        {
          key: 'action',
          label: '',
          thStyle: { width: '5%' },
          class: 'text-center'
        }
      ],
      listReport: [],
      stt: 1,
      custom_id: 0,
      modal: {
        rate: 23,
        from_currency: 2,
        to_currency: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      'customersOptions': 'Customer/listOptionsState',
      'moneyType': 'Setting/moneyTypeState',
      'detailReport': 'Report/detailReportState'
    }),
    isCheckAll: {
      get () {
        return this.$store.state.Report.pageListReport.isCheckAll
      },
      set (value) {
        this.$store.dispatch('Report/updateIsCheckAll', value)
      }
    },
    checkboxes: {
      get () {
        return this.$store.state.Report.pageListReport.checkboxes
      },
      set (value) {
        this.$store.dispatch('Report/updateCheckBoxes', value)
      }
    }
  },
  methods: {
    ...mapActions({
      'updateDetailReport': 'Report/updateDetailReport',
      'loadDetailReport': 'Report/loadDetailReport'
    }),
    parseData () {
      let parseDataReturn = null

      if (this.categorySelect === 'all') {
        parseDataReturn = _.compact(_.map(this.parseDataArr.details, (level0) => {
          if (isEmptyData(level0)) return
          if (this.customerSelect && level0.member_id !== this.customerSelect) {
            return
          }
          return {
            'id': level0.id,
            'is_exchanged': level0.is_exchanged,
            'title': level0.name,
            'gross_comm': formatNumber(level0.gross_comm),
            'mem_winloss': formatNumber(level0.mem_winloss),
            'total_vnd': formatNumber(level0.total_vnd),
            'total_usd': formatNumber(level0.total_usd),
            'children': _.compact(_.map(level0.summary, (level1, category) => {
              if (level1.datas === undefined || level1.datas.length === 0 || isEmptyData(level1)) return
              return {
                'title': category.toUpperCase(),
                'gross_comm': formatNumber(level1.gross_comm),
                'mem_winloss': formatNumber(level1.mem_winloss),
                'total_vnd': formatNumber(level1.total_vnd),
                'total_usd': formatNumber(level1.total_usd),
                'children': _.compact(_.map(level1.datas, (level2) => {
                  if (level2.datas === undefined || level2.datas.length === 0 || isEmptyData(level2)) return
                  return {
                    'title': level2.username,
                    'gross_comm': formatNumber(level2.gross_comm),
                    'mem_winloss': formatNumber(level2.mem_winloss),
                    'total_vnd': formatNumber(level2.total_vnd),
                    'total_usd': formatNumber(level2.total_usd),
                    'children': _.compact(_.map(level2.datas, (level3, game) => {
                      if (level3.datas === undefined || level3.datas.length === 0 || isEmptyData(level3)) return
                      return {
                        'title': game.toUpperCase(),
                        'gross_comm': null,
                        'mem_winloss': null,
                        'total_vnd': formatNumber(level3.total_vnd),
                        'total_usd': formatNumber(level3.total_usd),
                        'children': []
                      }
                    })) }
                })) }
            })) }
        }))
      } else {
        parseDataReturn = _.compact(_.map(this.parseDataArr.details, (level0) => {
          if (isEmptyData(level0) ||
            (level0.summary[this.categorySelect].total_vnd === '0' && level0.summary[this.categorySelect].total_usd === '0') ||
            (level0.summary[this.categorySelect].total_vnd === 0 && level0.summary[this.categorySelect].total_usd === 0)
          ) return
          if (this.customerSelect && level0.member_id !== this.customerSelect) {
            return
          }
          return {
            'id': level0.id,
            'title': level0.name,
            'gross_comm': formatNumber(level0.summary[this.categorySelect].gross_comm),
            'mem_winloss': formatNumber(level0.summary[this.categorySelect].mem_winloss),
            'total_vnd': formatNumber(level0.summary[this.categorySelect].total_vnd),
            'total_usd': formatNumber(level0.summary[this.categorySelect].total_usd),
            'children': _.compact(_.map(level0.summary[this.categorySelect].datas, (level2) => {
              if (level2.datas === undefined || level2.datas.length === 0 || isEmptyData(level2)) return
              return {
                'title': level2.username,
                'gross_comm': formatNumber(level2.gross_comm),
                'mem_winloss': formatNumber(level2.mem_winloss),
                'total_vnd': formatNumber(level2.total_vnd),
                'total_usd': formatNumber(level2.total_usd),
                'children': _.compact(_.map(level2.datas, (level3, game) => {
                  if (level3.datas === undefined || level3.datas.length === 0 || isEmptyData(level3)) return
                  return {
                    'title': game.toUpperCase(),
                    'gross_comm': null,
                    'mem_winloss': null,
                    'total_vnd': formatNumber(level3.total_vnd),
                    'total_usd': formatNumber(level3.total_usd),
                    'children': []
                  }
                }))
              }
            }))

          }
        }))
      }

      this.listReport = this.skeletorData(parseDataReturn, true)

      // reset
      this.stt = 1

      this.updateAllCheckBoxes(_.map(this.listReport, e => e.id))
    },
    skeletorData (data, rootLevel) {
      _.map(data, (e) => {
        let children = e.children ? e.children : []
        let _stt = ''
        let _showCheckbox = false
        let _showRollback = false

        if (rootLevel) {
          _stt = this.stt++
          _showCheckbox = e.is_exchanged === '0'
          _showRollback = e.is_exchanged === '1'
        }
        return _.extend(e, { custom_id: this.custom_id++, toggle: false, space: '', level: 1, children: children, stt: _stt, showCheckbox: _showCheckbox, showRollback: _showRollback })
      })

      return data
    },
    skeletorDataParent (data, parentId, parentLevel) {
      _.map(data, (e) => {
        let createSpace = '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp'.repeat(parentLevel)
        return _.extend(e, { parentId: parentId, space: createSpace, level: parentLevel + 1 })
      })

      return data
    },
    async fetchMember (index) {
      let childMembers = this.skeletorData(this.listReport[index].children, false)
      //
      let that = this
      let currentIndex = index + 1 // after the current index
      let currentLevel = this.listReport[index].level
      // current use index instead of id
      this.skeletorDataParent(childMembers, this.listReport[index].custom_id, currentLevel)

      _.each(childMembers, (e) => {
        // must use shadow copy splice if want to change data
        that.listReport.splice(currentIndex, 0, e) // insert into array at position
        currentIndex++
      })

      this.listReport[index].toggle = true
    },
    recursiveCloseSquare (id, isChild) {
      let that = this
      let childrenClose = _.filter(this.listReport, (e) => {
        return e.parentId === id
      })
      _.each(childrenClose, (e) => {
        that.recursiveCloseSquare(e.custom_id, true)
      })

      let index = _.findIndex(this.listReport, (e) => e.custom_id === id)

      this.listReport[index].toggle = false

      // only use with shallow copy method like splice only
      if (isChild) { this.listReport.splice(index, 1) }
    },
    applyNumberStyle (number) {
      return applyNumberStyle(number)
    },
    applyNumberFormat (number, locale) {
      return formatNumberByLocale(number, locale)
    },
    exchange () {
      let checkedArr = Object.values(this.$store.state.Report.pageListReport.checkboxes)

      api.report.exchangeReportDetail({
        'rate': this.modal.rate,
        'from': this.modal.from_currency,
        'to': this.modal.from_currency === 2 ? 1 : 2,
        'detail_ids': checkedArr // array of selected detail ID
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Đổi tiền thành công'
        })
        this.loadDetailReport(this.detailReport.selected_report_id)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    rollbackExchange (detailId) {
      api.report.rollbackExchangeReportDetail({
        'detail_id': detailId
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Đổi tiền thành công'
        })
        this.loadDetailReport(this.detailReport.selected_report_id)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    ...mapActions({
      updateAllCheckBoxes: 'Report/updateAllCheckBoxes',
      resetAll: 'Report/resetAll'
    })
  }
}
</script>
